import { Bar } from "../../types";
import { getEndOfDay, getStartOfDay, isDateBetween } from "../overview/calendar/calendar.utils";

const isDateBetweenAnyBar = (date: Date, bars: Bar[]) =>
  bars.some((booking) => {
    const bookingStart = getStartOfDay(booking.start);
    const bookingEnd = getEndOfDay(booking.end);
    return isDateBetween(date, bookingStart, bookingEnd);
  });

const isOverlapping = (start: Date, end: Date, bars: Bar[]) =>
  isDateBetweenAnyBar(start, bars) ||
  isDateBetweenAnyBar(end, bars) ||
  bars.some((booking) => {
    const bookingStart = getStartOfDay(booking.start);
    const bookingEnd = getEndOfDay(booking.end);
    return bookingStart.getTime() >= start.getTime() && bookingEnd.getTime() <= end.getTime();
  });

const separateOverlappingBars = (bars: Bar[] = []) => {
  if (!bars || !bars.length) {
    return [];
  }
  const rows: Bar[][] = [];
  bars
    .sort((b1, b2) => new Date(b1.start).getTime() - new Date(b2.start).getTime())
    .forEach((bar) => {
      if (!rows.length) {
        rows.push([bar]);
      } else {
        let shouldInsertNewRow = true;
        const barStart = new Date(bar.start);
        const barEnd = new Date(bar.end);
        for (let i = 0; i < rows.length; i++) {
          if (isOverlapping(barStart, barEnd, rows[i])) {
            continue;
          }
          rows[i].push(bar);
          shouldInsertNewRow = false;
          break;
        }
        if (shouldInsertNewRow) {
          rows.push([bar]);
        }
      }
    });
  return rows;
};

export default separateOverlappingBars;
